const MIME_BY_EXTENSION: Record<string, string> = {
  '.png': 'image/png',
  '.jpeg': 'image/jpeg',
  '.jpg': 'image/jpeg',
  '.heic': 'image/heic',
  '.pdf': 'application/pdf',
  '.csv': 'text/csv',
  '.xlsx':
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}

export const dropzoneAccept = (extensions: string[]) => {
  const accept: Record<string, string[]> = {}
  extensions.forEach((extension) => {
    const mime = MIME_BY_EXTENSION[extension.toLowerCase()]
    if (!mime) {
      return
    }
    accept[mime] = [...(accept[mime] || []), extension]
  })
  return accept
}

export const formatDropzoneRejectionError = (
  error: { code: string; message: string },
  maxSizeMb: number
): string => {
  if (error.code === 'file-too-large') {
    return `File must be ${maxSizeMb}MB or less`
  }
  if (error.code === 'file-invalid-type') {
    return 'File type not supported'
  }
  if (error.code === 'too-many-files') {
    return 'Too many files selected'
  }
  return error.message
}
